import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { validateFilterbarData } from 'components/validation/MarketplaceValidation'
import CategoryModal from 'components/public/CategoryModal'
import { Event } from '../../trackers/Tracking'
import { HiFilter } from 'react-icons/hi'
import { useAppContext } from 'context/AppContext'

const Pricemodal = ({ open, filterData, setFilterData, setPricemodalopen, modalData, setModalData }) => {
  const [error, setError] = useState('')
  const [, dispatch] = useAppContext()

  const handleClear = () => {
    setError('')
    setModalData((modalData) => ({ ...modalData, max_price: '', min_price: '' }))
    setFilterData((filterData) => ({
      ...filterData,
      max_price: '',
      min_price: '',
    }))
    setPricemodalopen(false)
  }

  const handleSave = () => {
    const data = { priceMin: modalData.min_price, priceMax: modalData.max_price }
    const newError = validateFilterbarData(data, {}, 'price')

    if (Object.keys(newError).length === 0) {
      setError('')
      setFilterData((filterData) => ({
        ...filterData,
        max_price: modalData.max_price,
        min_price: modalData.min_price,
      }))
      setPricemodalopen(false)
    } else {
      dispatch({
        type: 'setAlertType',
        alertType: 'error',
      })
      dispatch({
        type: 'setAlertText',
        alertText: Object.values(newError),
      })
    }
  }

  return (
    <Modal open={open}>
      <ModalWrapper>
        <Title>What price range are you looking for?</Title>
        <InputWrapper>
          <Label error={error.includes('Min')}>
            <Div1>min price</Div1>
            <Div>
              <Sign>$</Sign>
              <Input
                id="min-price"
                type="text"
                value={modalData.min_price}
                onChange={(e) => setModalData({ ...modalData, min_price: e.target.value })}
                onKeyDown={(event) => (event.keyCode === 13 || event.charCode === 13) && handleSave()}
              />
            </Div>
          </Label>
          <Div2>–</Div2>
          <Label error={error.includes('Max')}>
            <Div1>max price</Div1>
            <Div>
              <Sign>$</Sign>
              <Input
                id="max-price"
                type="text"
                value={modalData.max_price}
                onChange={(e) => setModalData({ ...modalData, max_price: e.target.value })}
                onKeyDown={(event) => (event.keyCode === 13 || event.charCode === 13) && handleSave()}
              />
            </Div>
          </Label>
        </InputWrapper>
        <ButtonWrapper>
          <Div3 id="clear-price" onClick={() => handleClear()}>
            Clear
          </Div3>
          <SaveButton id="save-price" onClick={() => handleSave()}>
            Save
          </SaveButton>
        </ButtonWrapper>
      </ModalWrapper>
    </Modal>
  )
}

const Lengthmodal = ({ open, filterData, setFilterData, setLengthmodalopen, modalData, setModalData }) => {
  const [error, setError] = useState('')
  const [, dispatch] = useAppContext()

  const handleClear = () => {
    setError('')
    setModalData((modalData) => ({ ...modalData, max_hours_of_coverage: '', min_hours_of_coverage: '' }))
    setFilterData((filterData) => ({
      ...filterData,
      min_hours_of_coverage: '',
      max_hours_of_coverage: '',
    }))
    setLengthmodalopen(false)
  }

  const handleSave = () => {
    const data = { lengthMin: modalData.min_hours_of_coverage, lengthMax: modalData.max_hours_of_coverage }
    const newError = validateFilterbarData(data, {}, 'length')

    if (Object.keys(newError).length === 0) {
      setError('')
      setFilterData((filterData) => ({
        ...filterData,
        min_hours_of_coverage: modalData.min_hours_of_coverage,
        max_hours_of_coverage: modalData.max_hours_of_coverage,
      }))
      setLengthmodalopen(false)
    } else {
      dispatch({
        type: 'setAlertType',
        alertType: 'error',
      })
      dispatch({
        type: 'setAlertText',
        alertText: Object.values(newError),
      })
    }
  }

  return (
    <Modal open={open}>
      <ModalWrapper>
        <Title>What length of shoot are you looking for?</Title>
        <InputWrapper>
          <Label error={error.includes('Min')}>
            <Div1>min hours</Div1>
            <Div>
              <Input
                id="min-length"
                type="text"
                value={modalData.min_hours_of_coverage}
                onChange={(e) => setModalData({ ...modalData, min_hours_of_coverage: e.target.value })}
                onKeyDown={(event) => (event.keyCode === 13 || event.charCode === 13) && handleSave()}
                length
              />
            </Div>
          </Label>
          <Div2>–</Div2>
          <Label error={error.includes('Max')}>
            <Div1>max hours</Div1>
            <Div>
              <Input
                id="max-length"
                type="text"
                value={modalData.max_hours_of_coverage}
                onChange={(e) => setModalData({ ...modalData, max_hours_of_coverage: e.target.value })}
                onKeyDown={(event) => (event.keyCode === 13 || event.charCode === 13) && handleSave()}
                length
              />
            </Div>
          </Label>
        </InputWrapper>
        <ButtonWrapper>
          <Div3 id="clear-length" onClick={() => handleClear()}>
            Clear
          </Div3>
          <SaveButton id="save-length" onClick={() => handleSave()}>
            Save
          </SaveButton>
        </ButtonWrapper>
      </ModalWrapper>
    </Modal>
  )
}

const Keywordmodal = ({
  open,
  filterData,
  setFilterData,
  setKeywordmodalopen,
  modalData,
  setModalData,
  setActive,
}) => {
  const [error, setError] = useState('')
  const [, dispatch] = useAppContext()

  const handleClear = () => {
    setError('')
    setModalData((modalData) => ({ ...modalData, key_word: '' }))
    setFilterData((filterData) => ({ ...filterData, key_word: '' }))
    setKeywordmodalopen(false)
  }

  const handleSave = () => {
    const data = { keyword: modalData.key_word }
    const newError = validateFilterbarData(data, {}, 'keyword')

    if (Object.keys(newError).length === 0) {
      setError('')
      setFilterData({ ...filterData, key_word: modalData.key_word })
      setActive(1)
      setKeywordmodalopen(false)
    } else {
      dispatch({
        type: 'setAlertType',
        alertType: 'error',
      })
      dispatch({
        type: 'setAlertText',
        alertText: Object.values(newError),
      })
    }
  }
  return (
    <Modal open={open}>
      <ModalWrapper>
        <Title>Search packages by keyword</Title>
        <InputWrapper>
          <Label error={error.includes('Keyword')}>
            <Div1>keyword</Div1>
            <Div>
              <Input
                id="input-keyword"
                type="text"
                value={modalData.key_word}
                onChange={(e) => setModalData({ ...modalData, key_word: e.target.value })}
                length
                onKeyDown={(event) => (event.keyCode === 13 || event.charCode === 13) && handleSave()}
              />
            </Div>
          </Label>
        </InputWrapper>
        <ButtonWrapper>
          <Div3 id="clear-keyword" onClick={() => handleClear()}>
            Clear
          </Div3>
          <SaveButton id="save-keyword" onClick={() => handleSave()}>
            Save
          </SaveButton>
        </ButtonWrapper>
      </ModalWrapper>
    </Modal>
  )
}

const MobileFilterModal = ({
  open,
  filterData,
  setFilterData,
  modalData,
  setModalData,
  setMobilemodalopen,
  active,
  setActive,
  categories,
}) => {
  const [error, setError] = useState('')
  const [categoryExpand, setCategoryExpand] = useState(true)
  const [mobileSelect, setMobileSelect] = useState(active)
  const [, dispatch] = useAppContext()

  const handleClear = () => {
    setError('')

    setModalData({
      max_price: '',
      min_price: '',
      max_hours_of_coverage: '',
      min_hours_of_coverage: '',
      key_word: '',
    })
    setFilterData({
      max_price: '',
      min_price: '',
      max_hours_of_coverage: '',
      min_hours_of_coverage: '',
      key_word: '',
    })
    setActive(1)
    setMobilemodalopen(false)
  }

  const handleSave = () => {
    const data = {
      priceMin: modalData.min_price,
      priceMax: modalData.max_price,
      lengthMin: modalData.min_hours_of_coverage,
      lengthMax: modalData.max_hours_of_coverage,
      keyword: modalData.key_word,
    }
    const newError = validateFilterbarData(data, {}, 'mobile')

    if (Object.keys(newError).length === 0) {
      setError('')
      setActive(mobileSelect)
      setFilterData(modalData)
      setMobilemodalopen(false)
    } else {
      dispatch({
        type: 'setAlertType',
        alertType: 'error',
      })
      dispatch({
        type: 'setAlertText',
        alertText: Object.values(newError),
      })
    }
  }
  return (
    <MobileModal open={open}>
      <ModalWrapper>
        <FilterTitle>
          Filters
          <CloseButton
            type="button"
            onClick={() => {
              setMobilemodalopen(false)
            }}
          >
            <CloseSpan1 />
            <CloseSpan2 />
          </CloseButton>
        </FilterTitle>
        <Title>Please type in the price range</Title>
        <InputWrapper>
          <Label error={error.includes('Min') && error.includes('Price')}>
            <Div1>min price</Div1>
            <Div>
              <Sign>$</Sign>
              <Input
                type="text"
                value={modalData.min_price}
                onChange={(e) => setModalData({ ...modalData, min_price: e.target.value })}
                onKeyDown={(event) => (event.keyCode === 13 || event.charCode === 13) && handleSave()}
              />
            </Div>
          </Label>
          <Div2>–</Div2>
          <Label error={error.includes('Max') && error.includes('Price')}>
            <Div1>max price</Div1>
            <Div>
              <Sign>$</Sign>
              <Input
                type="text"
                value={modalData.max_price}
                onChange={(e) => setModalData({ ...modalData, max_price: e.target.value })}
                onKeyDown={(event) => (event.keyCode === 13 || event.charCode === 13) && handleSave()}
              />
            </Div>
          </Label>
        </InputWrapper>
        <Title>Please type in the length of shoot range</Title>
        <InputWrapper>
          <Label error={error.includes('Min') && error.includes('Length')}>
            <Div1>min hours</Div1>
            <Div>
              <Input
                type="text"
                value={modalData.min_hours_of_coverage}
                onChange={(e) => setModalData({ ...modalData, min_hours_of_coverage: e.target.value })}
                onKeyDown={(event) => (event.keyCode === 13 || event.charCode === 13) && handleSave()}
                length
              />
            </Div>
          </Label>
          <Div2>–</Div2>
          <Label error={error.includes('Max') && error.includes('Length')}>
            <Div1>max hours</Div1>
            <Div>
              <Input
                type="text"
                value={modalData.max_hours_of_coverage}
                onChange={(e) => setModalData({ ...modalData, max_hours_of_coverage: e.target.value })}
                onKeyDown={(event) => (event.keyCode === 13 || event.charCode === 13) && handleSave()}
                length
              />
            </Div>
          </Label>
        </InputWrapper>
        <Title>Please type in keyword</Title>
        <InputWrapper>
          <Label error={error.includes('Keyword')}>
            <Div1>keyword</Div1>
            <Div>
              <Input
                type="text"
                value={modalData.key_word}
                onChange={(e) => setModalData({ ...modalData, key_word: e.target.value })}
                onKeyDown={(event) => (event.keyCode === 13 || event.charCode === 13) && handleSave()}
                length
              />
            </Div>
          </Label>
        </InputWrapper>
        <Title>Please select a category</Title>
        {categoryExpand && (
          <CategoryModal
            active={active}
            setActive={setActive}
            categories={categories}
            categoryOpen={categoryExpand}
            setCategoryOpen={setCategoryExpand}
            mobileSelect={mobileSelect}
            setMobileSelect={setMobileSelect}
            mobile={true}
          />
        )}
      </ModalWrapper>
      <ButtonWrapper>
        <Div3 id="clear-keyword" onClick={() => handleClear()}>
          Clear All
        </Div3>
        <SaveButton id="save-keyword" onClick={() => handleSave()}>
          Save
        </SaveButton>
      </ButtonWrapper>
    </MobileModal>
  )
}

const MarketplaceFilterBar = ({
  filterData,
  setFilterData,
  categoryOpen,
  setCategoryOpen,
  categoryName,
  active,
  setActive,
  categories,
  setPlaceId,
  setLocationValue,
  setLocation,
  setAreaFilter,
  setLocationFilter,
  setMobilemodalopen,
  mobilemodalopen,
}) => {
  const [modalData, setModalData] = useState({
    max_price: filterData.max_price,
    min_price: filterData.min_price,
    max_hours_of_coverage: filterData.max_hours_of_coverage,
    min_hours_of_coverage: filterData.min_hours_of_coverage,
    key_word: filterData.key_word,
  })

  const [pricemodalopen, setPricemodalopen] = useState(false)
  const [lengthmodalopen, setLengthmodalopen] = useState(false)
  const [keywordmodalopen, setKeywordmodalopen] = useState(false)
  const [priceActive, setPriceActive] = useState(0)
  const [lengthActive, setLengthActive] = useState(0)
  const [keywordActive, setKeywordActive] = useState(0)
  const [selectCatActive, setSelectCatActive] = useState(0)

  useEffect(() => {
    if (filterData.min_price !== '' || filterData.max_price !== '') {
      setPriceActive(1)
    } else {
      setPriceActive(0)
    }
    if (filterData.min_hours_of_coverage !== '' || filterData.max_hours_of_coverage !== '') {
      setLengthActive(1)
    } else {
      setLengthActive(0)
    }
    if (filterData.key_word !== '') {
      setKeywordActive(1)
    } else {
      setKeywordActive(0)
    }
    if (active === 1 || active === '1') {
      setSelectCatActive(0)
    } else {
      setSelectCatActive(1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData])

  const closeModal = (tag) => {
    if (tag !== 'price' && pricemodalopen) {
      setPricemodalopen(false)
    }
    if (tag !== 'length' && lengthmodalopen) {
      setLengthmodalopen(false)
    }
    if (tag !== 'keyword' && keywordmodalopen) {
      setKeywordmodalopen(false)
    }
    if (tag !== 'category' && categoryOpen) {
      setCategoryOpen(false)
    }
  }

  // MAKE SURE IF CATEGORY IS CHANGED KEYWORD IS CLEARED
  useEffect(() => {
    if (active !== 1 && active !== '1' && !!filterData.key_word) {
      setActive('1')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active])

  const handleClear = () => {
    if (
      !(
        filterData.min_price === '' &&
        filterData.max_price === '' &&
        filterData.min_hours_of_coverage === '' &&
        filterData.max_hours_of_coverage === '' &&
        filterData.key_word === '' &&
        active === '1'
      )
    ) {
      setModalData({
        max_price: '',
        min_price: '',
        max_hours_of_coverage: '',
        min_hours_of_coverage: '',
        key_word: '',
      })
      setPlaceId('')
      setLocationValue('')
      setLocation({})
      setAreaFilter(0)
      setFilterData({
        max_price: '',
        min_price: '',
        max_hours_of_coverage: '',
        min_hours_of_coverage: '',
        key_word: '',
      })
      setActive(1)
      setTimeout(() => {
        setLocationFilter(null)
      }, 50)
    }
  }

  return (
    <Container>
      {window.innerWidth > 900 ? (
        <Wrapper>
          <Subcontainer>
            <Tag
              id="tag-keyword"
              onClick={() => {
                if (!keywordmodalopen) {
                  Event('Filterbar', 'Keyword Modal Open Desktop', `Keyword Modal Open Desktop`)
                }
                closeModal('keyword')
                setKeywordmodalopen(!keywordmodalopen)
              }}
              open={keywordmodalopen}
              active={!!keywordActive}
            >
              {filterData.key_word !== '' ? filterData.key_word : 'Search'}
            </Tag>
            <Keywordmodal
              open={keywordmodalopen}
              filterData={filterData}
              setFilterData={setFilterData}
              modalData={modalData}
              setModalData={setModalData}
              keywordmodalopen={keywordmodalopen}
              setKeywordmodalopen={setKeywordmodalopen}
              setActive={setActive}
            />
          </Subcontainer>
          <Subcontainer>
            <Tag
              id="tag-category"
              onClick={() => {
                if (!categoryOpen) {
                  Event('Filterbar', 'Category Modal Open Desktop', `Category Modal Open Desktop`)
                }
                closeModal('category')
                setCategoryOpen(!categoryOpen)
              }}
              active={categoryName === 'All' ? false : true}
              open={categoryOpen}
            >
              {categoryName === 'All' ? 'Category' : categoryName}
            </Tag>
          </Subcontainer>
          <Subcontainer>
            <Tag
              id="tag-price"
              onClick={() => {
                if (!pricemodalopen) {
                  Event('Filterbar', 'Price Modal Open Desktop', `Price Modal Open Desktop`)
                }
                closeModal('price')
                setPricemodalopen(!pricemodalopen)
              }}
              open={pricemodalopen}
              active={!!priceActive}
            >
              {filterData.min_price !== '' || filterData.max_price !== ''
                ? filterData.min_price === '' || filterData.max_price === ''
                  ? filterData.min_price === ''
                    ? `Up to $${filterData.max_price}`
                    : `$${filterData.min_price}+`
                  : `$${filterData.min_price} - $${filterData.max_price}`
                : 'Price'}
            </Tag>
            <Pricemodal
              open={pricemodalopen}
              filterData={filterData}
              setFilterData={setFilterData}
              modalData={modalData}
              setModalData={setModalData}
              pricemodalopen={pricemodalopen}
              setPricemodalopen={setPricemodalopen}
            />
          </Subcontainer>
          <Subcontainer>
            <Tag
              id="tag-length"
              onClick={() => {
                if (!lengthmodalopen) {
                  Event('Filterbar', 'Length Modal Open Desktop', `Length Modal Open Desktop`)
                }
                closeModal('length')
                setLengthmodalopen(!lengthmodalopen)
              }}
              open={lengthmodalopen}
              active={!!lengthActive}
            >
              {filterData.min_hours_of_coverage !== '' || filterData.max_hours_of_coverage !== ''
                ? filterData.min_hours_of_coverage === '' || filterData.max_hours_of_coverage === ''
                  ? filterData.min_hours_of_coverage === ''
                    ? `Up to ${filterData.max_hours_of_coverage} hours`
                    : `${filterData.min_hours_of_coverage}+ hours`
                  : `${filterData.min_hours_of_coverage} - ${filterData.max_hours_of_coverage} hours`
                : 'Length of Shoot'}
            </Tag>
            <Lengthmodal
              open={lengthmodalopen}
              filterData={filterData}
              setFilterData={setFilterData}
              modalData={modalData}
              setModalData={setModalData}
              lengthmodalopen={lengthmodalopen}
              setLengthmodalopen={setLengthmodalopen}
            />
          </Subcontainer>
          <Subcontainer>
            <ClearButton onClick={() => handleClear()}>Clear Filters</ClearButton>
          </Subcontainer>
        </Wrapper>
      ) : (
        <div>
          <MobileFilterWrapper
            id="mobile-filter"
            onClick={() => {
              if (!mobilemodalopen) {
                Event('Filterbar', 'Mobile Filter Modal Open', `Mobile Filter Modal Open`)
              }
              setMobilemodalopen(!mobilemodalopen)
            }}
            open={mobilemodalopen}
            active={!!priceActive || !!lengthActive || !!keywordActive || !!selectCatActive}
          >
            {`Filters ${
              priceActive + lengthActive + keywordActive + selectCatActive !== 0
                ? priceActive + lengthActive + keywordActive + selectCatActive
                : ''
            }`}
            <FilterIcon />
          </MobileFilterWrapper>
          <MobileFilterModal
            open={mobilemodalopen}
            filterData={filterData}
            setFilterData={setFilterData}
            modalData={modalData}
            setModalData={setModalData}
            mobilemodalopen={mobilemodalopen}
            setMobilemodalopen={setMobilemodalopen}
            active={active}
            setActive={setActive}
            categories={categories}
          />
        </div>
      )}
    </Container>
  )
}

export default MarketplaceFilterBar

const Container = styled.div`
  display: flex;
  height: 36px;
  width: 100%;
`
const Wrapper = styled.div`
  display: flex;
`
const Title = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 0 20px;
  font-size: 16px;
  font-weight: 600;
  @media (max-width: 900px) {
    padding: 20px;
    border-top: 1px solid rgb(235, 235, 235);
  }
`
const Tag = styled.button`
  text-align: center;
  border: ${(props) => (props.active || props.open ? '1px solid var(--black)' : '1px solid #dddddd')};
  font-weight: 400;
  margin: 0 0.8em 0 0;
  // border-radius: 30px;
  color: var(--black);
  background: white;
  padding: 0.75em 1.25em;
  font-size: 12px;
  box-shadow: none;
  &:hover {
    border-color: var(--black);
  }
`
const MobileFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  color: #fff;
  background-color: var(--black);
  font-size: 14px;
  padding: 8px 18px !important;
  letter-spacing: 1px;
  border-radius: 9999px;
  box-shadow: rgb(0 0 0 / 8%) 0px 2px 4px 0px;
  cursor: pointer;
  z-index: 999;
`

const Modal = styled.div`
  display: ${(props) => (props.open ? 'inline-block' : 'none')};
  position: absolute;
  z-index: 99;
  top: 60px;
  width: auto;
  background: rgb(255, 255, 255);
  border: 0.5px solid rgba(118, 118, 118, 0.28);
  border-radius: 12px;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 10px 37px;
  overflow: hidden auto;
  white-space: normal;
  visibility: visible;
`

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 20px;
  justify-content: space-between;
  @media (max-width: 700px) {
    padding: 10px 20px 20px 20px;
    width: 70%;
  }
`

const Label = styled.label`
  position: relative;
  box-shadow: ${(props) =>
    props.error ? '#fb6340 0px 0px 0px 1px inset' : 'rgb(176, 176, 176) 0px 0px 0px 1px inset'};
  border-radius: 8px;
`

const Div = styled.div`
  display: flex;
  opacity: 1;
`

const Div1 = styled.div`
  position: absolute;
  top: 18px;
  left: 12px;
  right: 12px;
  color: rgb(113, 113, 113);
  pointer-events: none;
  transform-origin: 0% 0%;
  font-size: 16px;
  line-height: 20px;
  transition: -ms-transform 0.15s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s,
    -webkit-transform 0.15s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s,
    transform 0.15s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
  transform: translateY(-8px) scale(0.75);
  font-weight: 400;
  white-space: nowrap;
`

const Div2 = styled.div`
  margin: 22px 16px;
`
const Div3 = styled.div`
  font-size: 16px;
  cursor: pointer;
  padding: 10px;
  @media (max-width: 700px) {
    text-decoration: underline;
  }
  &:hover {
    border: none;
    background: rgb(247, 247, 247) !important;
    color: rgb(0, 0, 0) !important;
    border-radius: 8px;
  }
`

const SaveButton = styled.button`
  cursor: pointer;
  display: inline-block;
  position: relative;
  text-align: center;
  text-decoration: none;
  width: auto;
  touch-action: manipulation;
  font-size: 14px;
  line-height: 18px;
  border-radius: 8px;
  outline: none;
  padding: 8px 16px;
  transition: box-shadow 0.2s ease 0s, -ms-transform 0.1s ease 0s, -webkit-transform 0.1s ease 0s,
    transform 0.1s ease 0s;
  border: none;
  background: rgb(34, 34, 34);
  color: rgb(255, 255, 255);
  @media (max-width: 700px) {
    width: 100px;
    font-size: 16px;
  }
`
const Input = styled.input`
  width: 100%;
  border: none;
  font-size: 16px;
  margin: 28px 6px 10px;
  padding: ${(props) => (props.length ? '0 0 0 7px' : '0')};
  min-height: 1px;
  color: inherit;
  background-color: transparent;
  appearance: none;
`
const ButtonWrapper = styled.div`
  border-top: 1px solid rgb(235, 235, 235);
  padding: 12px 14px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 700px) {
    margin: 15px 0 0 0;
  }
`

const Subcontainer = styled.div`
  display: flex;
`

const Sign = styled.span`
  font-size: 16px;
  padding: 32px 0 0 12px;
`

const MobileModal = styled.div`
  display: ${(props) => (props.open ? 'block' : 'none')};
  overflow: auto;
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  border: 0.5px solid rgba(118, 118, 118, 0.28);
  box-shadow: rgba(0, 0, 0, 0.15) 0px 10px 37px;
  white-space: normal;
  z-index: 999;
  top: 0;
  position: fixed;
  left: 0;
`
const FilterTitle = styled.div`
  padding: 16px 20px;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  font-weight: 600;
`
const ClearButton = styled.button`
  font-size: 12px;
  text-align: center;
  background-color: var(--black);
  border-color: var(--black);
  color: #fff;
  padding: 8px 16px;
  font-weight: 400;
  &:hover {
    opacity: 0.85;
  }
`
const CloseButton = styled.button`
  font-size: 1.25rem;
  background-color: initial;
  border: 1px solid transparent;
  color: rgba(0, 0, 0, 0.6);
  border-color: transparent;
  text-align: right;
  overflow: visible;
  @media (max-width: 991.98px) {
    width: 20px;
    height: 20px;
    position: static;
    cursor: pointer;
  }
  &:hover {
    color: #000;
    border-radius: 8px;
  }
`
const CloseSpan1 = styled.span`
  display: block;
  position: absolute;
  width: 16px;
  height: 2px;
  border-radius: 2px;
  opacity: 1;
  background: #283448;
  transform: rotate(135deg);
  right: 20px;
`

const CloseSpan2 = styled(CloseSpan1)`
  transform: rotate(-135deg);
`

const FilterIcon = styled(HiFilter)`
  position: relative;
  color: #fff;
  font-size: 28px;
  padding-left: 8px;
`
